import config from '../../../config'
import {
  setupJsonJWTHeaders,
  genericHandleApiError,
  requestOk,
  ApiError,
} from './api-util'
import { fetchWithTimeout } from '../util/fetch'

const jsonOrBlobBody = response => {
  const contentType = response.headers.get('content-type')
  if (contentType && contentType.indexOf('application/json') !== -1) {
    return response.json()
  }
  if (contentType && contentType.indexOf('application/pdf') !== -1) {
    return response.blob()
  }
  return null
}

class Http {
  static get = (
    token,
    url,
    customTimeout,
    { accept = 'application/json' } = {},
  ) => {
    const timeout = customTimeout || config.requestTimeout

    const myInit = {
      method: 'GET',
      headers: new Headers({
        Accept: accept,
        Authorization: `Bearer ${token}`,
      }),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
    }

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(response => {
      if (requestOk(response)) {
        return jsonOrBlobBody(response)
      }
      return genericHandleApiError(response)
    })
  }

  static getBlob = (token, url, accept, customTimeout) => {
    const timeout = customTimeout || config.requestTimeout

    const myInit = {
      method: 'GET',
      headers: new Headers({
        Accept: accept,
        Authorization: `Bearer ${token}`,
      }),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
    }

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(response => {
      if (response.ok) {
        return response.blob()
      }
      throw new ApiError('Api Error', null, response.status, null, url)
    })
  }

  static getBlobWithFilename = (token, url, accept, customTimeout) => {
    const timeout = customTimeout || config.requestTimeout

    const myInit = {
      method: 'GET',
      headers: new Headers({
        Accept: accept,
        Authorization: `Bearer ${token}`,
      }),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
    }

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(response => {
      if (response.ok) {
        const filename = response.headers
          .get('content-disposition')
          .split('filename=')[1]
          .replace(/"/g, '')
        return response.blob().then(blob => ({
          blob,
          filename,
        }))
      }
      throw new ApiError('Api Error', null, response.status, null, url)
    })
  }

  static post(
    token,
    url,
    body,
    customTimeout,
    { accept = 'application/json' } = {},
  ) {
    const timeout = customTimeout || config.requestTimeout

    const myInit = {
      method: 'POST',
      headers: new Headers({
        Accept: accept,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body,
    }

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(response => {
      if (requestOk(response)) {
        return jsonOrBlobBody(response)
      }
      return genericHandleApiError(response, url, body)
    })
  }

  static postForBlob = (token, url, accept, body, customTimeout) => {
    const timeout = customTimeout || config.requestTimeout

    const myInit = {
      method: 'POST',
      headers: new Headers({
        Accept: accept,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body,
    }

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(response => {
      if (response.ok) {
        return response.blob()
      }
      throw new ApiError('Api Error', null, response.status, null, url, body)
    })
  }

  static put(
    token,
    url,
    body,
    customTimeout,
    { accept = 'application/json' } = {},
  ) {
    const timeout = customTimeout || config.requestTimeout

    const myInit = {
      method: 'PUT',
      headers: new Headers({
        Accept: accept,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body,
    }

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(response => {
      if (requestOk(response)) {
        return jsonOrBlobBody(response)
      }
      return genericHandleApiError(response, url, body)
    })
  }

  static patch(token, url, body, customTimeout) {
    const timeout = customTimeout || config.requestTimeout

    const myInit = {
      method: 'PATCH',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body,
    }

    return fetchWithTimeout(url, myInit, timeout, 'Timeout').then(response => {
      if (requestOk(response)) {
        return jsonOrBlobBody(response)
      }
      return genericHandleApiError(response, url, body)
    })
  }

  static delete = (token, url) => {
    const myInit = {
      method: 'DELETE',
      headers: setupJsonJWTHeaders(token),
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
    }

    return fetchWithTimeout(url, myInit, config.requestTimeout, 'Timeout').then(
      response => {
        if (requestOk(response)) {
          return jsonOrBlobBody(response)
        }
        return genericHandleApiError(response, url)
      },
    )
  }
}

export default Http
